(function () {
  angular.module('leanlaw').directive('llMatterQuickbooksStatus', MatterQuickbooksStatus);
  MatterQuickbooksStatus.$inject = ['accountingService'];
  function MatterQuickbooksStatus(accountingService) {
    return {
      restrict: 'EA',
      template: require('./views/matter-quickbooks-status.html'),
      scope: {
        account: '=ngModel',
        label: '='
      },
      link: function (scope, elem, attr) {
        scope.$watch('account', account => {
          scope.loading = true;
          if (account) {
            accountingService.getClient(account.id).then(account => {
              scope.account.name = account.name;
              scope.valid = true;
            }).catch(() => {
              scope.valid = false;
            }).finally(() => {
              scope.loading = false;
            });
          }
        });
      }
    };
  }
})();